import React from "react";
import { Divider, Box, makeStyles, Typography, RaiseColors } from "client/componentLibrary";
import DealroomlistingCardBadge from "components/ListingCard/DealroomlistingCardBadge";
import classnames from "classnames";
import CoreAttributeText from "./CoreAttributeText";
import { trackEvent, TrackingEventContext, TrackingEventNames, TrackingEventPageView } from "utils/Analytics";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    cardContainer: {
      borderRadius: "4px",
      border: "1px solid ".concat(RaiseColors.gray100),
      position: "relative",
      width: "100%"
    },
    carouselContainer: {
      cursor: "pointer",
      overflow: "hidden",
      borderRadius: "3px 3px 0px 0px",
      // Sets 3:2 Ratio on the carousel container
      position: "relative",
      width: "100%",
      paddingTop: "66.66%",
      "& img": {
        height: "100%"
      }
    },
    carousel: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    body: {
      padding: "12px 16px 15px 16px",
      "&:hover": {
        cursor: "pointer"
      }
    },
    coreAttributes: {
      padding: "16px 0px 0px 0px",
      display: "flex"
    },
    engagementSection: {
      margin: "12px 0px",
      minHeight: 22
    },
    attributeText: {
      display: "flex",
      alignItems: "baseline"
    },
    reppedListingContainer: {
      backgroundColor: RaiseColors.white,
      width: "100%",
      textAlign: "center",
      marginTop: 2,
      marginBottom: 2,
      borderRadius: "4px 4px 0px 4px"
    }
  };
});
var VerticalListingCard = function VerticalListingCard(_ref) {
  var FileCarouselSection = _ref.FileCarouselSection,
    CategoryDisplaySection = _ref.CategoryDisplaySection,
    listingName = _ref.listingName,
    listingType = _ref.listingType,
    neighborhood = _ref.neighborhood,
    coreAttributes = _ref.coreAttributes,
    EngagementSection = _ref.EngagementSection,
    onCardClick = _ref.onCardClick,
    isReppedListing = _ref.isReppedListing,
    showClientActivityCount = _ref.showClientActivityCount,
    ClientActivityAttributes = _ref.ClientActivityAttributes,
    customCardContainerClass = _ref.customCardContainerClass,
    isListingsView = _ref.isListingsView,
    sublandlord = _ref.sublandlord;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs(Box, {
    className: classnames(classes.cardContainer, customCardContainerClass),
    "data-testid": "listing-card-container",
    children: [" ", isReppedListing && /*#__PURE__*/_jsx("div", {
      className: classes.reppedListingContainer,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_medium",
        weight: "semibold",
        color: RaiseColors.black,
        "data-testid": "repped-listing-text",
        children: "Your Listing"
      })
    }), /*#__PURE__*/_jsx(Box, {
      className: classes.carouselContainer,
      children: /*#__PURE__*/_jsx(Box, {
        className: classes.carousel,
        "data-testid": "carousel-section",
        children: FileCarouselSection
      })
    }), /*#__PURE__*/_jsx(Divider, {
      color: RaiseColors.gray100
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.body,
      onClick: function onClick(e) {
        if (onCardClick) {
          onCardClick(e);
        }
        if (isListingsView) {
          trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
            pageView: TrackingEventPageView.CLIENT_DEALROOM_LISTINGS,
            context: TrackingEventContext.LISTING_CARD
          });
        }
      },
      "data-testid": "listing-card-link",
      children: [CategoryDisplaySection && CategoryDisplaySection, /*#__PURE__*/_jsx("div", {
        style: {
          marginTop: 0.5
        },
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "paragraph_medium",
          weight: "semibold",
          color: RaiseColors.black,
          display: "block",
          children: listingName
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginTop: "0.25px"
        },
        children: /*#__PURE__*/_jsxs(Typography, {
          noWrap: true,
          display: "block",
          color: RaiseColors.gray300,
          children: [neighborhood && " ".concat(neighborhood, " "), listingType && "\xB7 ".concat(listingType)]
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginTop: "0.25px"
        },
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.gray300,
          children: sublandlord
        })
      }), showClientActivityCount && /*#__PURE__*/_jsx("div", {
        "data-testid": "client-activity-count",
        children: /*#__PURE__*/_jsx(DealroomlistingCardBadge, {
          dealroomlisting: ClientActivityAttributes
        })
      }), coreAttributes && /*#__PURE__*/_jsxs(Box, {
        className: classes.coreAttributes,
        children: [/*#__PURE__*/_jsxs(Box, {
          width: "50%",
          children: [/*#__PURE__*/_jsx(CoreAttributeText, {
            attribute: coreAttributes.sqft
          }), /*#__PURE__*/_jsx(CoreAttributeText, {
            attribute: coreAttributes.term
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          ml: 2.5,
          children: [/*#__PURE__*/_jsx(CoreAttributeText, {
            attribute: coreAttributes.askingRate
          }), /*#__PURE__*/_jsx(CoreAttributeText, {
            attribute: coreAttributes.occupancy
          })]
        })]
      })]
    }), EngagementSection && /*#__PURE__*/_jsxs("div", {
      "data-testid": "engagement-section",
      children: [/*#__PURE__*/_jsx(Divider, {
        color: RaiseColors.gray100
      }), /*#__PURE__*/_jsx(Box, {
        className: classes.engagementSection,
        children: EngagementSection
      })]
    })]
  });
};
export default VerticalListingCard;